<template>
  <Tables
    ref="tableGrid"
    :columns="['Nome', 'Tipo de Pessoa', 'Idade', 'Email']"
    :showTipFooter="false"
    @Load="onLoadBirthdays"
  >
    <tr v-for="obj in this.objList" v-bind:key="obj.id">
      <TableColumn :IsText="true" :status="1" :value="obj.nome ? obj.nome : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.tipoPessoa ? obj.tipoPessoa : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.dataNascimento ? moment().diff(moment.tz(obj.dataNascimento, 'America/Sao_Paulo'), 'years').toString() : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.email ? obj.email : ''" />
    </tr>
  </Tables>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'

export default {
  name: 'BirthdayTable',
  mixins: [ActionsForm],
  methods: {
    async onLoad () {
      await this.onLoadBirthdays()
    },
    async onLoadBirthdays () {
      const response = await PersonRepository.GetAniversariantesPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
      this.onResultGrid(response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/StartPage/BirthdayTable.vue